import $ from 'jquery';
import BootstrapData from 'models/BootstrapData';
import { unmountReact } from '../utils/reactRoot';
import _ from 'underscore';
import Global from 'models/Global';
import MainBaseView from 'views/MainBaseView';
import FeatureToggleUtils from 'FeatureToggleUtils';
import ReactEditProfileView from './ReactEditProfileView';
import PeopleProfileContainer from './reactViews/unityEmbeds/PeopleProfile/PeopleProfileContainer';
import { initializeSnowplowTrackerIfEnabled } from '../utils/SnowplowUtils';
import { renderReactComponentWithRedux } from '../hocs/withReduxProvider';

const isWebLoginUsed = () => !FeatureToggleUtils.isFeatureEnabled('oldLogin');

const MainEditProfileView = MainBaseView.extend({
    initialize: async function(options) {
        options = options || {};
        FeatureToggleUtils.mergeFeatureToggleWithConfig();
        MainBaseView.prototype.initialize.apply(this, arguments);
        this.publicWebsiteBaseUrl = Global.get('event').getPublicWebsiteBaseUrl();

        if (isWebLoginUsed()) {
            const isPeopleV2Community = options.bootstrapData.event?.features?.communityVersion === 'PEOPLE_V2';

            const targetSelector = isPeopleV2Community ? '.main-react-view' : '.edit-profile';
            this.reactRoot = document.querySelector(targetSelector);
            this.event = options.bootstrapData.event;
            this.render(isPeopleV2Community);
        } else {
            const { default: EditProfileView } = require('views/EditProfileView');

            new EditProfileView({
                model: Global.get('me'),
                el: this.$('.edit-profile')
            });
        }

        initializeSnowplowTrackerIfEnabled();
    },

    render(isPeopleV2Community) {
        if (isPeopleV2Community) {
            renderReactComponentWithRedux(
                PeopleProfileContainer,
                this.reactRoot
            );

            return;
        }

        renderReactComponentWithRedux(
            ReactEditProfileView,
            this.reactRoot,
            { groupId: this.event.groupId }
        );
    },

    remove() {
        unmountReact(this.reactRoot);
    },
});

const event = BootstrapData('bootstrap-data-event');
const me = BootstrapData('bootstrap-data-me');
const config = BootstrapData('bootstrap-data-config');
const isJoinedObject = BootstrapData('bootstrap-data-isJoinedObject');
const isWidgetObject = BootstrapData('bootstrap-data-isWidgetObject');
const siteConf = BootstrapData('bootstrap-data-siteConf');
const settings = BootstrapData('bootstrap-data-settings');
const isCookieConsentEnabled = BootstrapData('bootstrap-data-isCookieConsentEnabled');

export default new MainEditProfileView({
    el: $(document.body),
    bootstrapData: {
        event: event,
        eventID: event.id,
        settings: settings,
        me: me,
        config: config,
        siteConf: siteConf,
        isJoined: isJoinedObject.isJoined,
        isWidget: isWidgetObject.isWidget,
        isCookieConsentEnabled
    },
});
